import { createBlock } from 'factories/block';
import { InteractionProps, repeat } from './interaction';
import { createLayout } from 'factories/layout';
import { createFeedbackBlock } from './feedback';
import { colors } from 'styles/variables';
import { Block, cloneBlock, Blocks } from '@chameleoncreator/creator-app';
import { flatten } from 'factories/utils';
import { createContinueBtn } from './continueBtn';
import { createEditableBtn } from './editableBtn';
import Correct_default from 'assets/Correct_loop.gif'; // Correct_default.svg';
import Incorrect_default from 'assets/Incorrect_loop.gif'; // Incorrect_default.svg';
import uuid from 'uuidv4';
import { getSId } from '../utils';
import { createMediaBlock } from './media';

const { lPink, lGrey0, lGrey2, lTeal0 } = colors;

export type SelectOptionsInteractionProps = InteractionProps & {
  answerCount: number;
};

export const createSelectOptionBlock = () => {
  return createBlock('SelectOption', [createBlock('Text')], {
    props: {
      type: 'SelectOption',
      values: ['Option 1', 'Option 2', 'Option 3'],
      correctAnswer: 0,
    },
  });
};

export const createSelectOptionsBlock = (count: number) => {
  return createBlock('SelectOptionsRoot', [
    createBlock('Question', [createBlock('Text')]),

    createBlock('SelectOptions', [
      ...repeat(() => createSelectOptionBlock(), count),
    ]),
    createEditableBtn({ type: 'Submit_Button', label: 'Submit' }),

    createFeedbackBlock({}),
  ]);
};

const contentForColumn = (count: number) => (i: number) => {
  return [
    () =>
      createMediaBlock({
        src: undefined,
        child: 1,
        useBackgroundControls: true,
      }),
    () =>
      createBlock('InteractionColumn', [
        createSelectOptionsBlock(count),
        createMediaBlock({
          child: 0,
          isAdditionalMedia: true,
        }),
      ]),
  ][i];
};

export const addSelectOption = (
  block: Block,
  position: number
): [Block, Blocks?] => {
  if (block.type === 'SelectOptions') {
    const selectOptionBlock = createSelectOptionBlock();

    const selectOptionBlockRef = {
      id: selectOptionBlock.id,
      type: 'Ref',
    };
    const [newBlocks] = flatten(selectOptionBlock);

    const nextBlock = cloneBlock(block);
    (nextBlock.children as Block[]).splice(position, 0, selectOptionBlockRef);

    return [nextBlock, newBlocks];
  }
  return [block, undefined];
};

export const removeSelectOption = (
  block: Block,
  position: number
): [Block, Blocks?] => {
  if (block.type === 'SelectOptions') {
    const selectOptionBlock = createSelectOptionBlock();
    const [newBlocks] = flatten(selectOptionBlock);

    const nextBlock = cloneBlock(block);
    (nextBlock.children as Block[]).splice(position, 1);

    return [nextBlock, newBlocks];
  }
  return [block, undefined];
};

export const createSelectOptionsInteractionBlock = (
  props: SelectOptionsInteractionProps
) => {
  const {
    numberOfAttempts = 1,
    showCorrectAnswer = 0,
    lockDown = 0,
    score = true,
    style,
  } = props as any;

  return createBlock(
    'Interaction',
    [
      createLayout(
        contentForColumn(props.answerCount),
        props.columnCount,
        props.columnsReversed
      ),
      createBlock('SingleColumnLayout', [
        createBlock('Column', [createContinueBtn(style)], {
          props: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap',
          },
          meta: {
            subType: 'ButtonBlock',
          },
        }),
      ]),
    ],
    {
      props: {
        name: props.name,
        sId: getSId('interaction'),
        style: props.style,

        numberOfAttempts,
        showCorrectAnswer,
        lockDown,
        score,
      },
      meta: {
        subType: 'SelectOptions',
        layout: `${props.columnCount === 0 ? 'OneColumn' : 'TwoColumns'}${
          props.columnsReversed ? 'Reversed' : ''
        }`,
      },
    }
  );
};

export const create = createSelectOptionsInteractionBlock;
export const interactionConfig = {};
